"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDTM = exports.SEVE = exports.SEOP = exports.EDDK = exports.DOLE = exports.SEST = exports.SIDE = exports.EBDM = exports.SUEZ = void 0;
exports.SUEZ = {
    'primary-brand': '#9bcd41',
    'brand-default': '#9bcd41',
    'brand-dark': '#699c00',
    'brand-light': '#e0e7c7'
};
exports.EBDM = {
    'primary-brand': '#59B9FF',
    'brand-default': '#59B9FF',
    'brand-dark': '#0089CC',
    'brand-light': '#93EBFF'
};
exports.SIDE = {
    'primary-brand': '#004990',
    'brand-default': '#004990',
    'brand-dark': '#002362',
    'brand-light': '#4B74C1',
    'primary-contrast': '#FFFFFF'
};
exports.SEST = {
    'primary-brand': '#004990',
    'brand-default': '#004990',
    'brand-dark': '#002362',
    'brand-light': '#4B74C1',
    'primary-contrast': '#FFFFFF'
};
exports.DOLE = {
    'primary-brand': '#00B0DF',
    'brand-default': '#00B0DF',
    'brand-dark': '#0080AD',
    'brand-light': '#63E2FF'
};
exports.EDDK = {
    'primary-brand': '#175BA7',
    'brand-default': '#175BA7',
    'brand-dark': '#003377',
    'brand-light': '#5987D9',
    'primary-contrast': '#FFFFFF'
};
exports.SEOP = {
    'primary-brand': '#00ABC9',
    'brand-default': '#00ABC9',
    'brand-dark': '#007C98',
    'brand-light': '#5EDDFC',
    'primary-contrast': '#FFFFFF'
};
exports.SEVE = {
    'primary-brand': '#82C3CF',
    'brand-default': '#82C3CF',
    'brand-dark': '#51929E',
    'brand-light': '#B4F6FF'
};
exports.EDTM = {
    'primary-brand': '#00A4B6',
    'brand-default': '#00A4B6',
    'brand-dark': '#007586',
    'brand-light': '#5AD6E8',
    'primary-contrast': '#FFFFFF'
};
exports.default = {
    SUEZ: exports.SUEZ,
    EBDM: exports.EBDM,
    SIDE: exports.SIDE,
    SEST: exports.SEST,
    DOLE: exports.DOLE,
    EDDK: exports.EDDK,
    SEOP: exports.SEOP,
    SEVE: exports.SEVE,
    EDTM: exports.EDTM
};
